"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./GroupTitleExample.css");
var __1 = require("../../../../");
var GroupTitleExample = /** @class */ (function (_super) {
    __extends(GroupTitleExample, _super);
    function GroupTitleExample(props) {
        return _super.call(this, props) || this;
    }
    GroupTitleExample.prototype.render = function () {
        var isDecodingNeeded = this.props.data.isDecodingRequired ? this.props.data.isDecodingRequired : false;
        return (React.createElement("div", { "data-test-id": this.props.testId },
            React.createElement("div", { className: styles.psmTitle },
                React.createElement(__1.Label, { data: { text: this.props.data.title, isDecodingRequired: isDecodingNeeded } }),
                React.createElement(__1.Label, { data: { text: this.props.data.code, isDecodingRequired: isDecodingNeeded } }))));
    };
    return GroupTitleExample;
}(React.Component));
exports.default = GroupTitleExample;
//# sourceMappingURL=GroupTitleExample.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/GroupTitleExample/GroupTitleExample.js
// module id = 1249
// module chunks = 8